import { caseStudyContent } from "./caseStudyContent"

export default function QuoteSection() {
  return (
    <section className="flex w-full translate-x-[calc(50vw-50%-1.5rem)] flex-col items-center">
      <figure className="m-0 flex w-full flex-col items-center gap-6 md:gap-9">
        <blockquote className="m-0 w-full text-center text-[24px] font-semibold leading-none tracking-[-0.06em] text-[#171717] lg:text-[36px] lg:leading-9">
          <p className="m-0">{caseStudyContent.quote}</p>
        </blockquote>
        <figcaption className="flex flex-col items-center gap-2.5 text-[14px] leading-5 md:flex-row">
          <span className="font-medium text-[#171717]">{caseStudyContent.attribution.name}</span>
          <span className="font-normal text-[#4D4D4D]">{caseStudyContent.attribution.role}</span>
        </figcaption>
      </figure>
    </section>
  )
}
